export const setAnnouncementAsSeen = () => ({
  type: "ANNOUNCEMENT_SEEN",
});
